/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "./QuickNav.css";

const QuickNav = ({ items = [] }) => {
  const [activeId, setActiveId] = useState("");

  // Generate expected IDs once
  const itemIds = items.map((item) => item.toLowerCase().replace(/\s+/g, "-"));

  // Helper: Find which section is currently in view
  const getActiveId = () => {
    const scrollY = window.scrollY + 100; // Offset to prioritize top sections

    for (let i = itemIds.length - 1; i >= 0; i--) {
      const id = itemIds[i];
      const element = document.getElementById(id);
      if (element) {
        const { offsetTop } = element;
        if (scrollY >= offsetTop) {
          return id;
        }
      }
    }
    return itemIds[0] || "";
  };

  // Handle scroll and hash changes
  useEffect(() => {
    if (items.length === 0) return;

    // Initial active ID
    const updateActive = () => {
      const id = getActiveId();
      setActiveId(id);
    };

    // Also handle direct hash navigation (e.g., page load with #industries)
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      if (itemIds.includes(hash)) {
        setActiveId(hash);
        // Optional: slight delay to ensure scroll completed
        setTimeout(updateActive, 100);
      } else {
        updateActive();
      }
    };

    // Attach listeners
    window.addEventListener("scroll", updateActive, { passive: true });
    window.addEventListener("hashchange", handleHashChange);

    // Initial check
    handleHashChange();

    return () => {
      window.removeEventListener("scroll", updateActive);
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [items]);

  if (items.length === 0) return null;

  return (
    <div className="quick-nav-container">
      <div className="quick-nav">
        {items.map((item, index) => {
          const id = item.toLowerCase().replace(/\s+/g, "-");
          const isActive = activeId === id;
          return (
            <a
              key={index}
              href={`#${id}`}
              className={`quick-nav-item${isActive ? " active" : ""}`}
            >
              {item}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default QuickNav;
